import { useEffect, useState } from "react";

type ToolRunLike = { name: string; status: string };

/** Shared display progress: phase floors from the store + time creep while a matched tool is running. */
export function useTimedPhaseDisplayProgress(options: {
  active: boolean;
  phaseProgress: number;
  toolStartedAt: number | null;
  toolRuns: ToolRunLike[];
  matchesTool: (toolName: string) => boolean;
  computeToolRunningProgress: (phaseProgress: number, toolStartedAt: number, toolName: string) => number;
}): number {
  const {
    active,
    phaseProgress,
    toolStartedAt,
    toolRuns,
    matchesTool,
    computeToolRunningProgress,
  } = options;
  const [displayProgress, setDisplayProgress] = useState(phaseProgress);

  useEffect(() => {
    setDisplayProgress(phaseProgress);
  }, [phaseProgress]);

  useEffect(() => {
    if (!active) {
      return;
    }

    const runningTool = toolRuns.find(
      (run) => run.status === "running" && matchesTool(run.name),
    );
    if (!runningTool || toolStartedAt == null) {
      return;
    }

    const toolName = runningTool.name;

    const tick = () => {
      setDisplayProgress((prev) => Math.max(
        prev,
        computeToolRunningProgress(phaseProgress, toolStartedAt, toolName),
      ));
    };

    tick();
    const intervalId = window.setInterval(tick, 200);
    return () => window.clearInterval(intervalId);
  }, [active, toolRuns, toolStartedAt, phaseProgress, matchesTool, computeToolRunningProgress]);

  return displayProgress;
}
